import { TextField, Button, FormControl, FormLabel, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const GraphQueryForm = () => {
  const [graphQueryFormData, setGraphQueryFormData] = useState({
    neo4j_uri: "",
    neo4j_user: "",
    neo4j_password: "",
    query: "",
    depth_search: "",
    llm_model_name: "",
    embedding_model_name: "",
  });

  const llmModelOptions = ["LLM Model A", "LLM Model B", "LLM Model C"];
  const embeddingModelOptions = ["Embedding Model A", "Embedding Model B", "Embedding Model C"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGraphQueryFormData({
      ...graphQueryFormData,
      [name]: value,
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(graphQueryFormData);
  };


  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Neo4j URI</FormLabel>
            <TextField name="neo4j_uri" value={graphQueryFormData.neo4j_uri} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Neo4j User</FormLabel>
            <TextField name="neo4j_user" value={graphQueryFormData.neo4j_user} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Neo4j Password</FormLabel>
            <TextField type="password" name="neo4j_password" value={graphQueryFormData.neo4j_password} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Query</FormLabel>
            <TextField name="query" value={graphQueryFormData.query} onChange={handleChange} multiline />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Depth Search</FormLabel>
            <TextField type="number" name="depth_search" value={graphQueryFormData.depth_search} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>LLM Model Name</FormLabel>
            <TextField select name="llm_model_name" value={graphQueryFormData.llm_model_name} onChange={handleChange}>
              {llmModelOptions.map((model) => (
                <MenuItem key={model} value={model}>
                  {model}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Embedding Model Name</FormLabel>
            <TextField select name="embedding_model_name" value={graphQueryFormData.embedding_model_name} onChange={handleChange}>
              {embeddingModelOptions.map((model) => (
                <MenuItem key={model} value={model}>
                  {model}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default GraphQueryForm;
